import { FC } from 'react';

const iconHorns = require('./icon_horns.svg');

export const IconHorns: FC = () => {
  return <img alt="icon_horns" height={114} src={iconHorns} width={130} />;
};

IconHorns.displayName = 'IconHorns';
